export enum LoginType {
  'withNewEmail',
  'fromToken',
  'normal',
}
